module.exports = __webpack_public_path__ + "static/img/shui.fd478df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logistics/shui.png
// module id = keyh
// module chunks = 44